var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCodeRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_11",
    "data-name": "Differenzmenge 11",
    d: "M17,19H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H17a2,2,0,0,1,2,2V17A2,2,0,0,1,17,19ZM12.334,6h0l-.933.933L14.467,10,11.4,13.067l.933.933,4-4-4-4ZM7,6H7L3,10l4,4,.933-.933L4.866,10,7.934,6.934,7,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCodeRegular);
export default __webpack_public_path__ + "static/media/file-code-regular.7c36120cfe8a67c7c8f51666f9bbadc9.svg";
export { ForwardRef as ReactComponent };